// extracted by mini-css-extract-plugin
export var option = "_52-0";
export var optionCard = "_52-f";
export var optionContent = "_52-g";
export var optionIcon = "_52-i";
export var optionIconBox = "_52-h";
export var optionLabel = "_52-j";
export var optionPill = "_52-m";
export var optionPillBadge = "_52-p";
export var optionPillIcon = "_52-n";
export var optionPillLabel = "_52-o";
export var optionRadio = "_52-k";
export var optionRadioInner = "_52-l";
export var optionReveal = "_52-2";
export var optionRevealDelay0 = "_52-3";
export var optionRevealDelay1 = "_52-4";
export var optionRevealDelay10 = "_52-d";
export var optionRevealDelay11 = "_52-e";
export var optionRevealDelay2 = "_52-5";
export var optionRevealDelay3 = "_52-6";
export var optionRevealDelay4 = "_52-7";
export var optionRevealDelay5 = "_52-8";
export var optionRevealDelay6 = "_52-9";
export var optionRevealDelay7 = "_52-a";
export var optionRevealDelay8 = "_52-b";
export var optionRevealDelay9 = "_52-c";
export var optionSelected = "_52-1";